import { useSelector } from 'react-redux';
export const selRoom = (state) => state.virtualRoom;
export const useVirtualRoom = () => useSelector((state) => selRoom(state));
//# sourceMappingURL=virtualRoom.js.map